// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"ImageFile__pc_only___1kSA7","sp_only":"ImageFile__sp_only___2ewVZ","image_file":"ImageFile__image_file___1ZoXh"};